import { render, staticRenderFns } from "./BookingHistoryTab.vue?vue&type=template&id=398c7f78&scoped=true&"
import script from "./BookingHistoryTab.vue?vue&type=script&lang=js&"
export * from "./BookingHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c7f78",
  null
  
)

export default component.exports